// layouts/PublicLayout.jsx
import { Outlet } from "react-router-dom";
import Footer from "../components/buyer/Footer";
import Header from "../components/buyer/Header1";

const PublicLayout = () => (
  <>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
  </>
);

export default PublicLayout;
